import React from "react";
import activityOverviewStyle from "./activityOverviewStyle";
import { Button, Grid } from "@mui/material";
import ActivityIcon from "../../../components/Activities/ActivityIcon";
import { getCaseLink, getProductData, getProductNameBy } from "../../../services/Product/ProductService/productService";
import { ReportProblemOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";
import ActivityActions from "../ActivityActions/ActivityActions";
import AssignedUser from "./AssignedUser";
import { Activity } from "../../../types/Activity";
import { BackofficeUser } from "../../../types/BackofficeUser";
import dayjs from "dayjs";

type OverviewActivityEntryProps = {
  activity: Activity<BackofficeUser>;
  update: Function;
};

const OverviewActivityEntry = ({ activity, update }: OverviewActivityEntryProps) => {
  const productClassName = getProductNameBy("lbProductClass", activity.case.lbProductClass);

  return (
    <Grid container spacing={1}>
      <Grid size={1}>
        <ActivityIcon activity={activity} />
      </Grid>
      <Grid sx={activityOverviewStyle.smallFont} size={11}>
        <Grid container spacing={1} sx={{
          alignItems: "center"
        }}>
          <Grid
            sx={{ ...activityOverviewStyle.singleLineOverflowHidden, ...activityOverviewStyle.subject }}
            size={7}>
            {activity.subject}
          </Grid>
          <Grid size={5}>
            {getProductData(productClassName, "generalLabel")}
          </Grid>
          <Grid sx={activityOverviewStyle.singleLineOverflowHidden} size={12}>
            {(activity.note || "").replace(/(<([^>]+)>)/gi, "")}
          </Grid>
          <Grid size={7}>
            {activity.case.label || activity.case.lbProductId}
          </Grid>
          <Grid size={5}>
            <AssignedUser activity={activity} updateActivities={update} />
          </Grid>
          <Grid size={4}>
            {dayjs(activity.dueDate).format("DD.MM.YYYY")}
          </Grid>
          <Grid size={3}>
            {activity.dueTime !== "allDay" ? <span>{activity.dueTime}&nbsp;Uhr</span> : "-"}
          </Grid>
          <Grid size={5}>
            {activity.mandatory ? (
              <Grid
                container
                sx={{
                  alignItems: "center",
                  justifyContent: "space-between"
                }}>
                <Grid size={1}>
                  <ReportProblemOutlined sx={activityOverviewStyle.warningIcon} />
                </Grid>
                <Grid size={10}>
                  Pflicht
                </Grid>
              </Grid>
            ) : (
              "Keine Pflicht"
            )}
          </Grid>
          <Grid size={4}>
            <Button
              variant={"contained"}
              color={"primary"}
              sx={activityOverviewStyle.activityButton}
              component={Link}
              to={getCaseLink(
                {
                  productClassName: productClassName,
                  id: activity.case.lbProductId,
                },
                "",
              )}
              fullWidth={false}
            >
              Zum Fall
            </Button>
          </Grid>
          <ActivityActions activity={activity} updateActivities={update} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OverviewActivityEntry;
